import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;

  .pagination {
    display: flex;
    margin-top: 35px;

    a {
      display: block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      color: ${({theme}) => theme.colors.grayscale[400]};
    }

    .active a {
      font-weight: 600;
      color: ${({theme}) => theme.colors.primary[400]};
    }

    .arrow a {
      background-image: url(/assets/pagination/arrow.svg);
      background-size: 100% auto;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .double a {
      background-image: url(/assets/pagination/arrow-double.svg);
      background-size: 100% auto;
    }

    .rotate a {
      transform: rotate(180deg);
    }
  }
`;